var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.form,{ref:_vm.field,tag:"component",attrs:{"patient":_vm.patient,"item":_vm.item,"field":_vm.field,"action":_vm.action},on:{"updated":_vm.handleUpdated,"created":_vm.handleCreated,"show-template-list":_vm.handleShowTemplateList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }